import { Plan } from "store/entities/subscriptions";

const plans = [Plan.Team, Plan.Business, Plan.Enterprise];

const features = {
  downgrade: {
    [Plan.Enterprise]: {
      [Plan.Team]: [
        "Create more than 5 teams",
        "Add more than 5 forwarding addresses",
        "Add more than 1 custom domain",
        "Create more than 5 email templates",
        "Have more than 5 active rules",
        "Have more than 5 active custom fields",
        "Create more than 20 shared and 5 private macros",
      ],
      [Plan.Business]: [
        "Everything from the Team plan",
        "Up to 100 teams",
        "Up to 100 forwarding addresses",
        "Up to 100 custom domains",
        "Up to 100 email templates",
        "Up to 50 active rules",
        "Up to 20 active custom fields",
        "Up to 100 shared and 20 private macros",
      ],
    },
    [Plan.Business]: {
      [Plan.Team]: [
        "Create more than 5 teams",
        "Add more than 5 forwarding addresses",
        "Add more than 1 custom domain",
        "Create more than 5 email templates",
        "Have more than 5 active rules",
        "Have more than 5 active custom fields",
        "Create more than 20 shared and 5 private macros",
      ],
    },
  },
  unchanged: {
    [Plan.Team]: [
      "Up to 5 teams",
      "Up to 5 forwarding addresses",
      "Up to 1 custom domain",
      "Up to 5 email templates",
      "Up to 5 active rules",
      "Up to 5 active custom fields",
      "Up to 20 shared and 5 private macros",
    ],
    [Plan.Business]: [
      "Everything from the Team plan",
      "Up to 100 teams",
      "Up to 100 forwarding addresses",
      "Up to 100 custom domains",
      "Up to 100 email templates",
      "Up to 50 active rules",
      "Up to 20 active custom fields",
      "Up to 100 shared and 20 private macros",
    ],
    [Plan.Enterprise]: [
      "Everything from the Business plan with no limits",
      "Dedicated account manager",
      "Product training",
      "Software engineer support",
      "Security assistance",
      "White label",
    ],
  },
  upgrade: {
    [Plan.Team]: [
      "Up to 5 teams",
      "Up to 5 forwarding addresses",
      "Up to 1 custom domain",
      "Up to 5 email templates",
      "Up to 5 active rules",
      "Up to 5 active custom fields",
      "Up to 20 shared and 5 private macros",
    ],
    [Plan.Business]: [
      "Everything from the Team plan",
      "Up to 100 teams",
      "Up to 100 forwarding addresses",
      "Up to 100 custom domains",
      "Up to 100 email templates",
      "Up to 50 active rules",
      "Up to 20 active custom fields",
      "Up to 100 shared and 20 private macros",
    ],
    [Plan.Enterprise]: [
      "Everything from the Business plan with no limits",
      "Dedicated account manager",
      "Product training",
      "Software engineer support",
      "Security assistance",
      "White label",
    ],
  },
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function normalize(plan: string) {
  return plan.toLowerCase().replace(" ", "");
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function getPlanIndex(plan: string) {
  return plans.findIndex(el => normalize(el) === normalize(plan));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isUpsell(currentPlan: string, formerPlan: string) {
  return getPlanIndex(currentPlan) >= getPlanIndex(formerPlan);
}

export function getSummaryInfo(currentPlan: Plan, formerPlan: string, recommendedPlan: Plan | null): string[] {
  const isRecommendedLowerThanFormer = recommendedPlan && getPlanIndex(recommendedPlan) < getPlanIndex(formerPlan);

  if (currentPlan === formerPlan || isRecommendedLowerThanFormer) {
    return features.unchanged[currentPlan as keyof typeof features.unchanged];
  }

  const upgrade = features.upgrade[currentPlan as keyof typeof features.upgrade];

  const downgrade = features.downgrade[formerPlan as keyof typeof features.downgrade];

  return isUpsell(currentPlan, formerPlan) ? upgrade : downgrade[currentPlan as keyof typeof downgrade];
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getDefaultSummaryInfo() {
  return features.upgrade[Plan.Team];
}
